import { render, staticRenderFns } from "./IconCogOutline.vue?vue&type=template&id=3d2fd754"
import script from "./IconCogOutline.vue?vue&type=script&lang=js"
export * from "./IconCogOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports